import React, { useEffect, useState } from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import PublishIcon from '@material-ui/icons/Publish';
import { longLocationTypes } from '../../constants/LongLocationType';
import { connect } from 'react-redux';
import { deleteBookStartInventory, postBookStartInventory } from '../../store/booksLld/actions';
import { getDateAsString } from '../../services/DateService';
import { BACKEND_HOST } from '../../constants/api';
import { CircularProgress, Input } from '@material-ui/core';
import { KOBOO_LIGHT_RED } from '../../constants/colors';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';

const styles = () => (
  {
    buttonCell: {
      padding: 0,
      textAlign: 'center',
    },
    row: {
      width: '100%',
    },
  }
);

const BookingsLldRow = (props) => {
  const {
    bookLld,
    authUser,
    error,
    openDialog,
    postBookStartInventory,
    deleteBookStartInventory,
    classes,
  } = props;

  const startDate = new Date(bookLld.date * 1000);
  const startDateString = getDateAsString(startDate);
  const [uploadStartInventoryLoading, setUploadStartInventoryLoading] = useState(false);
  const [startInventory, setStartInventory] = useState(0);

  useEffect(() => {
    setUploadStartInventoryLoading(false);
  }, [error]);

  if (bookLld && startInventory === 0) {
    setStartInventory(bookLld.start_inventory);
  }

  const handleStartInventoryInputChange = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    setUploadStartInventoryLoading(true);
    postBookStartInventory(authUser.ma, bookLld.id, file).then((data) => {
      setUploadStartInventoryLoading(false);
      setStartInventory(data.start_inventory);
    });
  };

  const deleteStartInventory = () => {
    setUploadStartInventoryLoading(true);
    deleteBookStartInventory(authUser.ma, bookLld.id).then(() => {
      setUploadStartInventoryLoading(false);
      setStartInventory(null);
    });
  };

  const handleDeleteStartInventory = (event) => {
    event.preventDefault();
    event.stopPropagation();
    openDialog(
      'Suppression de l\'état des lieux de début',
      'Êtes-vous certain de vouloir supprimer l\'état des lieux de début ?',
      () => deleteStartInventory,
    );
  };

  const handleShowStartInventory = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (bookLld.start_inventory) {
      window.open(`${BACKEND_HOST}/${bookLld.start_inventory}`, '_blank');
    }
  };

  return (
    <TableRow
      key={bookLld.id}
      hover
      tabIndex={-1}
      className={classes.row}
    >
      <TableCell>
        {bookLld.renter_name}
      </TableCell>
      <TableCell>
        {bookLld.id}
      </TableCell>
      <TableCell>
        {bookLld.username}
      </TableCell>
      <TableCell>
        {startDateString}
      </TableCell>
      <TableCell>
        {
          bookLld.lldCount
          + ' ' + longLocationTypes[bookLld.lldType]
          + (
            (
              bookLld.lltCount > 1 && bookLld.lltType !== 'month'
            )
              ? 's'
              : ''
          )
        }
      </TableCell>
      <TableCell>
        {bookLld.is_electric
          ? 'Electrique'
          : 'Mecanique'}
      </TableCell>
      <TableCell className={classes.buttonCell}>
        {uploadStartInventoryLoading
          ? <CircularProgress />
          :
          (
            startInventory
              ? <React.Fragment>
                <IconButton
                  color="primary"
                  component="span"
                  onClick={handleShowStartInventory}
                >
                  <VisibilityIcon />
                </IconButton>
                <IconButton
                  color="secondary"
                  style={{ color: KOBOO_LIGHT_RED }}
                  component="span"
                  onClick={handleDeleteStartInventory}
                >
                  <DeleteIcon />
                </IconButton>
              </React.Fragment>
              : <label htmlFor={`start-inventory-${bookLld.id}-file`}>
                <Input
                  id={`start-inventory-${bookLld.id}-file`}
                  accept="image/*"
                  type="file"
                  style={{ display: 'none' }}
                  onChange={handleStartInventoryInputChange}
                />
                <IconButton
                  color="primary"
                  component="span"
                >
                  <PublishIcon />
                </IconButton>
              </label>
          )
        }
      </TableCell>
      {/* Empty TableCell to fill all the TableRow, need to find a fix */}
      <TableCell></TableCell>
    </TableRow>
  );
};

export default compose(
  connect(
    null,
    {
      postBookStartInventory,
      deleteBookStartInventory,
    },
  ),
  withStyles(styles),
)(BookingsLldRow);



// WEBPACK FOOTER //
// ./src/components/BookingsLld/BookingsLldRow.jsx